import React, { FC } from 'react';
import { NavLink } from 'react-router';
import { cn } from '../utils';

type Props = {
  to: string;
  children: React.ReactNode;
  disabled: boolean;
};

const PaginationArrow: FC<Props> = ({ to, disabled, children }) => {
  return (
    <NavLink
      to={to}
      className={cn(
        `
          flex h-10 w-10 items-center justify-center rounded-full
          bg-[linear-gradient(94.59deg,_#AD52F9_0%,_#CD8CFF_100%)] text-white
        `,
        disabled &&
          'bg-[linear-gradient(94.59deg,_rgba(173,82,249,0.3)_0%,_rgba(205,140,255,0.3)_100%)]',
      )}
    >
      {children}
    </NavLink>
  );
};

export default PaginationArrow;
